import type {
  UserGetPortfolioChartInput,
  UserGetWalletPortfolioChartInput,
} from '../api'
import { api } from '../api'

export const getUserPortfolio = async () => {
  return await api.v1.userGetUserPortfolio()
}

export const getUserPortfolioChart = async (
  data: UserGetPortfolioChartInput,
) => {
  return await api.v1.userGetUserPortfolioChart(data)
}
export const getWalletPortfolioChart = async (
  data: UserGetWalletPortfolioChartInput,
) => {
  return await api.v1.userGetWalletPortfolioChart(data)
}

export const getUserPerformance = async () => {
  return await api.v1.userGetUserPerformance()
}
